import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { DocumentLibrarySearchComponent } from '../../../../../document-search/document-library-search/document-library-search.component';
import { DocumentSearchResult } from '../../../../../document/models/documentSearchResult';
import { EqmsScopeManagementService } from '../../../../../shared/services/eqms-scope-management.service';
import { SkillPersistenceService } from '../../../../../skill/services/skill-persistence.service';
import { SkillService } from '../../../../../skill/services/skill.service';
import { SkillConstants } from '../../../../../skill/constants/skill-constants';
import { Skill } from '../../../../../skill/models/skill';
import { SkillDetail } from '../../../../../skill/models/skill-detail.model';
import { TrainingItemDetails } from '../../../../../curriculum/models/trainingItemDetails';
import { catchError, throwError } from 'rxjs';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-skill-document-details',
  templateUrl: './skill-document-details.component.html',
  styleUrls: ['./skill-document-details.component.scss']
})
export class SkillDocumentDetailsComponent implements OnInit {
  @Output() activateTabIndex = new EventEmitter<number>();
  feature:string = SkillConstants.Skill_Feature;
  documentSearchResult : DocumentSearchResult[] = [];
  isskillSaveInProgress: boolean = false;
  selectedDocuments: DocumentSearchResult[] = [];
  items: MenuItem[] = [];
  showAddButton : boolean = false;
  listOfSelectedDocuments:string[]=[];
  linkedTrainingItem : any;
  skillDetails !: SkillDetail;
  @Input() selectedScope!: any;
  @Input() skillCode !: string;
  scope?:number;
  trainingItemsList : TrainingItemDetails[]=[];
  skill !: Skill;
  trainingItemNumbers : string[] = [];
  isUpdate: boolean = false;
  addAndClose : boolean = false;
  errorCount : number = 0;
  eqmsScopes:number[] = [];
  displayDataCollected: string[] = [];
  trainingItemsDataToDisplay : string[] = [];
  skillDocumentDetails : string = SkillConstants.SkillDocumentDetails;
  
  
  @ViewChild(DocumentLibrarySearchComponent)
  private docSearch!: DocumentLibrarySearchComponent;

  constructor(private messageService : MessageService,
    private skillService : SkillService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private skillPersistenceService : SkillPersistenceService){
    this.items = [
    {
        label: 'Add',
        command: this.add
    }
  ]
  }
  
  ngOnInit() : void{
    this.skillPersistenceService.closeAndResetTrainingItemSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetskillSlider(); }
    })
    this.skillPersistenceService.resetSelectionAfterAdd$.subscribe((reset) => {
      if (reset) { this.clearSelections(); }
    })
  }

  onSelectionOrDeselection = (documents: DocumentSearchResult[]) => {
    let selectedDocumentsList: string[] = [];
    documents.forEach(element => {
      selectedDocumentsList.push(element.documentNumber);
    });
    this.displayDataCollected=[]
    this.displayDataCollected = selectedDocumentsList;
    this.selectedDocuments = [];
    this.selectedDocuments = cloneDeep(documents);
  }

  addskillAndClose(){
    this.addAndClose = true;
    this.getLinkedItems(this.addAndClose);
  }

  add = () => {
    this.addAndClose = false;
    this.getLinkedItems(this.addAndClose);
  };

  closeAndResetskillSlider(){
    this.selectedDocuments = [];
    this.displayDataCollected = [];
    this.documentSearchResult = [];
    this.showAddButton = false;
  }

  clearSelections() {
    this.selectedDocuments = [];
    this.displayDataCollected = [];
    if (this.docSearch) {
      this.docSearch.clearSelectionsAfterBulkOperation();
    }
  }

  showOrHideAddButton = (displayAddBtn: boolean) => {
    this.showAddButton = displayAddBtn;
  }


  getLinkedItems(addAndClose:boolean)
  {
    this.eqmsScopes = [];
    this.displayDataCollected = Object.assign([], this.displayDataCollected);
    this.errorCount=0;
    this.skillService.getSkillByCode(this.skillCode).subscribe((skill)=>{
      this.skill = skill;
      this.skillPersistenceService.updateSkillDetails(skill);
      if(this.skill != null)
      {
        this.isUpdate = true;
      }
      this.validateAndCreateOrUpdateskill(addAndClose);
      this.docSearch.getLinkedItemsSelection()
    });
  }

  validateAndCreateOrUpdateskill(addAndClose:boolean){
    if(this.displayDataCollected.length<=0)
    {
      this.validateToSelectAtleastOneTrainingItem();
    }
    else
    {
        if(this.isUpdate){
          this.validateIfTrainingItemIsAlreadySaved(this.displayDataCollected);
        }
        else{
          this.validateIfTrainingItemIsAlreadySelected(this.displayDataCollected);
        }
          this.skillService.getLatestDocumentDetail(this.displayDataCollected)
        .pipe(
          catchError((err) => {
            this.messageService.add({
              severity: SkillConstants.Severity_Err,
              summary: `${err.error}`,
              life: 20000 
            });
            return throwError(() => err);
          })
        ).subscribe({
          next: (serviceData) => {
            this.getParentScopesAndCompare(serviceData, this.isUpdate, this.addAndClose);
          },
          error: () => {}
        })
    }
  }

  validateToSelectAtleastOneTrainingItem(){
    this.errorCount=0;
    this.messageService.add({
      severity: SkillConstants.Severity_Err,
      summary: `${SkillConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
      life: 20000
    });
    this.errorCount++;
  }

  validateIfTrainingItemIsAlreadySelected(matchingDocuments : any[]){
    var documentNumbers : string[] = [];
    matchingDocuments.find(element => {
      if(Object.values(this.trainingItemsDataToDisplay.indexOf(element)>=0))
      {
        documentNumbers.push(element);
      }
      else
      {
        this.trainingItemsDataToDisplay.push(element);
      }
      })
      this.displayDataCollected = documentNumbers.filter( x => !this.trainingItemsDataToDisplay.find(a=> a==x) );
      const sameElements = documentNumbers.filter( x => this.trainingItemNumbers.find(a=> a == x));
      if(sameElements.length > 0){
        this.validationMessageForTrainingItemAlreadyExisting(sameElements);
      }
  }

  validateIfTrainingItemIsAlreadySaved( matchingDocuments : any[]){
    var documentNumbers : string[] = [];
    this.trainingItemNumbers = [];
    const activeTrainingItemIds: string[] = [];
    this.skill.linkedTrainingItems?.find(element=>{
      this.trainingItemNumbers.push(element.trainingItemId);
      if (element.status !== SkillConstants.Skill_StatusRemoved) {
        activeTrainingItemIds.push(element.trainingItemId);
      }
    })
    matchingDocuments.find(element => {
      if(Object.values(activeTrainingItemIds.indexOf(element)>=0))
      {
        documentNumbers.push(element);
       
      }
      else
      {
        this.listOfSelectedDocuments.push(element);
      }
      });
      this.displayDataCollected = documentNumbers.filter( x => !activeTrainingItemIds.find(a=> a==x) );
      const sameElements = documentNumbers.filter( x => activeTrainingItemIds.find(a=> a == x));
      if(sameElements.length > 0)
      {
        this.validationMessageForTrainingItemAlreadyExisting(sameElements);
      }
  }


    //since scopes are not matching, we are trying to get its parent scopes and compare with selected form scopes
    getParentScopesAndCompare(serviceData: any[], isUpdate: boolean, addAndClose: boolean) {
      const scopes: any[] =[];
      //fetch scopes here
    this.selectedScope.map((scope: any) => {
      scopes.push(scope);
    });
      const matchingDocuments: any[] = [];
      const mismatchedDocuments: any[] = [];
      
      serviceData.forEach((data) => {
        const { eqmsScopes } = data;    
        const hasMatch = eqmsScopes.some((scope: number) => scopes.includes(scope));    
        if (hasMatch) {
          matchingDocuments.push(data);
        } else {
          mismatchedDocuments.push(data);
        }
      });
      if (mismatchedDocuments.length) {
        this.displayScopeValidationMessage(mismatchedDocuments);
      }
      if (matchingDocuments.length) {
        this.selectedItems(matchingDocuments);
        this.updateskill(matchingDocuments,addAndClose);  
      }
    }

    selectedItems(serviceData : any[]){
      if (!this.trainingItemsDataToDisplay || this.trainingItemsDataToDisplay.length === 0) {
        this.trainingItemsDataToDisplay = serviceData;
      } else {
        this.trainingItemsDataToDisplay.push(...serviceData);
      }
    }

    updateskill(matchingDocuments : any[],addAndClose : boolean){
        this.skillPersistenceService.prepareDataForDocumentTrainingItem(matchingDocuments,
          this.isUpdate, this.skill);
        if (this.skillPersistenceService.duplicateTrainingItemNumbersWithRemoveStatus.length > 0) {
          const trainingItemCode = this.skillPersistenceService.duplicateTrainingItemNumbersWithRemoveStatus.map((item) => `${item}`).join(',');
          const validationMessage = SkillConstants.Skill_Warning_TrainingItemMovedToActiveMessage.replace(
            'TrainingItems',
            `\n${trainingItemCode}`
          );
          this.messageService.add({
            severity: SkillConstants.Severity_Warning,
            summary: `${validationMessage}`,
            sticky: true
          });
        }
        this.skillPersistenceService.updateSkill(addAndClose);
    }

    displayScopeValidationMessage(mismatchedDocuments: any[]) {
      this.errorCount = 0;
      const documentNumbersString = mismatchedDocuments.map((document) => `  ${document.number}`).join(', ');
      const validationMessage = SkillConstants.Selected_Documentscopes_Not_Matching_Error_Message.replace(
        'DocumentNumbers',
        `\n${documentNumbersString}`
      );
      this.messageService.add({
        severity: SkillConstants.Severity_Err,
        summary: `${validationMessage}`,
        life: 20000 
      });
      this.errorCount++;  
    }

    validationMessageForTrainingItemAlreadyExisting(matchingDocuments : any[]){
      this.errorCount = 0;
      const documentNumbersString = matchingDocuments.map((document) => `  ${document}`).join(', ');
        const validationMessage = SkillConstants.LinkedDocument_AlreadyExists_InSkill.replace(
          'DocumentNumbers',
          `\n${documentNumbersString}`
        );
        this.messageService.add({
          severity: SkillConstants.Severity_Err,
          summary: `${validationMessage}`,
          life: 20000 
        });
        this.errorCount++;
    }
}
